import { title } from 'process'
import { Joyrider } from '@/components/organisms/site/Joyrider'
import { useRcTranslation } from '@/core/hooks/useRcTranslation'
import { TranslationNamespace } from '@/core/translation'

export const TeamAdminJoyride = ({ external }: { external?: Date }) => {
  const { t } = useRcTranslation([TranslationNamespace.Competition])

  const steps = [
    {
      target: '.create-team',
      title: t('competition:admin-joyride.create-team-title'),
      content: t('competition:admin-joyride.create-team')
    },
    {
      target: '.filter-teams',
      title: t('competition:admin-joyride.filter-teams-title'),
      content: t('competition:admin-joyride.filter-teams')
    },
    {
      target: '.select-teams',
      title: t('competition:admin-joyride.select-teams-title'),
      content: t('competition:admin-joyride.select-teams')
    },
    {
      target: '.team-actions',
      title: t('competition:admin-joyride.team-actions-title'),
      content: t('competition:admin-joyride.team-actions')
    }
  ]

  return (
    <Joyrider
      external={external}
      steps={steps}
      localKey='team-admin-joyride'
      prompt={t('competition:admin-joyride.prompt')}
    />
  )
}
